module.exports = __webpack_public_path__ + "img/13.2e985b97.png";